// $(document).ready(function() {
//     $('.tab a').click(function () {
//         $('.tab a.active').removeClass('active');
//         $(this).addClass('active');
//     });
// });

// /* Product Variant Hierarchy & Button Validation */
// (function() {
//   // New: Validation logic to lock/unlock the Add to Basket button
//   const validateSelection = () => {
//     const container = document.querySelector('.product-info');
//     if (!container) return;
    
//     const atcButton = document.querySelector('button[name="add"], .btn--add-to-cart, #AddToCart-mobile');
//     const varItems = Array.from(container.querySelectorAll('varitem'));
    
//     // Check if every variant row has a selected option
//     const allSelected = varItems.every(item => {
//       return item.querySelector('input[type="radio"]:checked') !== null;
//     });

//     if (atcButton) {
//       if (allSelected) {
//         atcButton.disabled = false;
//         atcButton.style.opacity = "1";
//         atcButton.textContent = "Add to Basket"; // Restore original text
//       } else {
//         atcButton.disabled = true;
//         atcButton.style.opacity = "0.5";
//         atcButton.textContent = "Select Options"; // Guide the user
//       }
//     }
//   };

//   const updateMatrix = () => {
//     const container = document.querySelector('.product-info');
//     if (!container) return;

//     const varItems = Array.from(container.querySelectorAll('varitem'));
//     const jsonTag = container.querySelector('script[type="application/json"]');
//     if (!jsonTag || varItems.length < 2) return;

//     const variants = JSON.parse(jsonTag.textContent);
//     const selections = varItems.map(item => {
//       const checked = item.querySelector('input[type="radio"]:checked');
//       return checked ? checked.value : null;
//     });

//     varItems.forEach((item, index) => {
//       if (index === 0) return; // Top level always active

//       const radios = item.querySelectorAll('input[type="radio"]');
//       const parentIsSelected = selections[index - 1] !== null;

//       radios.forEach(radio => {
//         if (!parentIsSelected) {
//           radio.disabled = true;
//           return;
//         }

//         const testPath = [...selections];
//         testPath[index] = radio.value;

//         const isPossible = variants.some(v => {
//           for (let i = 0; i <= index; i++) {
//             const val = (i === index) ? radio.value : selections[i];
//             if (val && v.options[i] !== val) return false;
//           }
//           return v.available; 
//         });

//         radio.disabled = !isPossible;
//       });
//     });
//   };

//   document.body.addEventListener('input', (e) => {
//     if (!e.target.matches('.product-info input[type="radio"]')) return;

//     const varItems = Array.from(document.querySelectorAll('varitem'));
//     const currentIndex = varItems.indexOf(e.target.closest('varitem'));

//     // Hierarchy Reset: Uncheck everything below the changed option
//     varItems.forEach((item, index) => {
//       if (index > currentIndex) {
//         const inputs = item.querySelectorAll('input[type="radio"]');
//         inputs.forEach(input => { input.checked = false; });
//         const labelText = item.querySelector('.current-option');
//         if (labelText) labelText.textContent = 'Select an option';
//       }
//     });

//     setTimeout(() => {
//         updateMatrix();
//         validateSelection(); // Run validation after reset and matrix update
//     }, 50);
//   });

//   // Initial Runs
//   setTimeout(() => {
//       updateMatrix();
//       validateSelection();
//   }, 200);
// })();

// /* Gallery "View All" Grid Logic */
// document.querySelectorAll('.slider-small-custom').forEach(slider => {
//   slider.addEventListener('click', (e) => {
//     const thumb = e.target.closest('.swiper-slide-custom:nth-child(10)');
//     if (thumb && !slider.classList.contains('show-all-images')) {
//       slider.classList.add('show-all-images');
      
//       const instance = slider.swiper || $(slider).data('swiper');
//       if (instance) {
//         instance.destroy(true, true);
//       }
      
//       window.scrollBy({ top: 100, behavior: 'smooth' });
//     }
//   });
// });

$(document).ready(function(){$(".tab a").click(function(){$(".tab a.active").removeClass("active"),$(this).addClass("active")})}),function(){let e=()=>document.querySelectorAll('form[action*="/cart"] button[type="submit"]'),t=t=>{let r=e();r.forEach(e=>{e.disabled=!t,e.style.opacity=t?"1":"0.5"})},r=()=>{let e=document.querySelector(".product-info");if(!e)return;let r=Array.from(e.querySelectorAll("varitem")),l=r.every(e=>null!==e.querySelector('input[type="radio"]:checked'));t(l)},l=()=>{let e=document.querySelector(".product-info");if(!e)return;let t=Array.from(e.querySelectorAll("varitem")),r=e.querySelector('script[type="application/json"]');if(!r||t.length<2)return;let l=JSON.parse(r.textContent),o=t.map(e=>{let t=e.querySelector('input[type="radio"]:checked');return t?t.value:null});t.forEach((e,t)=>{if(0===t)return;let r=e.querySelectorAll('input[type="radio"]'),i=null!==o[t-1];r.forEach(e=>{if(!i){e.disabled=!0;return}let r=l.some(r=>{for(let l=0;l<=t;l++){let i=l===t?e.value:o[l];if(i&&r.options[l]!==i)return!1}return r.available});e.disabled=!r})})};document.body.addEventListener("input",e=>{if(!e.target.matches('.product-info input[type="radio"]'))return;let t=Array.from(document.querySelectorAll("varitem")),o=t.indexOf(e.target.closest("varitem"));t.forEach((e,t)=>{if(t>o){let r=e.querySelectorAll('input[type="radio"]');r.forEach(e=>e.checked=!1);let l=e.querySelector(".current-option");l&&(l.textContent="Select an option")}}),setTimeout(()=>{l(),r()},50)}),window.addEventListener("load",()=>{l(),r()})}();